export const SIZE = {
    2: "3xs",
    4: "2xs",
    8: "xs",
    16: "s",
    24: "m",
    32: "l",
    40: "xl",
    48: "2xl",
    56: "3xl",
    64: "4xl",
};
//# sourceMappingURL=size.js.map